import readTextOfSideFrom from './readTextOfSideFrom.vue'
export default readTextOfSideFrom
